"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DesktopService = void 0;
const core_1 = require("@angular/core");
let DesktopService = class DesktopService {
    constructor() {
        this.defaultWallpaper = 'https://picsum.photos/id/11/1920/1080';
        this.wallpaperUrl = (0, core_1.signal)(this.defaultWallpaper);
        try {
            const savedWallpaper = localStorage.getItem('windows-wallpaper');
            if (savedWallpaper) {
                this.wallpaperUrl.set(savedWallpaper);
            }
        }
        catch (e) {
            console.warn('Could not access localStorage for wallpaper.', e);
            this.wallpaperUrl.set(this.defaultWallpaper);
        }
        (0, core_1.effect)(() => {
            try {
                localStorage.setItem('windows-wallpaper', this.wallpaperUrl());
            }
            catch (e) {
                console.warn('Could not save wallpaper to localStorage.', e);
            }
        });
    }
    setWallpaper(url) {
        this.wallpaperUrl.set(url);
    }
};
exports.DesktopService = DesktopService;
exports.DesktopService = DesktopService = __decorate([
    (0, core_1.Injectable)({ providedIn: 'root' }),
    __metadata("design:paramtypes", [])
], DesktopService);
